import React, { useState } from "react";
import { getFirestore, doc, updateDoc } from "firebase/firestore";
import Chip from "@mui/material/Chip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useAtom } from "jotai";
import {
  themeAtom,
  labelsAtom,
  labelColoursAtom,
  isAdminAtom,
} from "../-Atoms";

const PermanentLabelChip = ({ label, kanbanBoard, jobData, setLabelMenuOpen }) => {
  const [theme] = useAtom(themeAtom);
  const [labels] = useAtom(labelsAtom);
  const [labelColours] = useAtom(labelColoursAtom);
  const [isAdmin] = useAtom(isAdminAtom);

  let labelData = {};
  labels.forEach((l) => {
    if (l.id === label) {
      labelData = l;
    }
  });
  const [contextMenu, setContextMenu] = useState(null);

  const handleContextMenu = (event) => {
    event.preventDefault();
    if (contextMenu) {
      setContextMenu(null);
    } else {
      setContextMenu({
        mouseX: event.clientX + 2,
        mouseY: event.clientY - 6,
      });
    }
  };

  const handleClose = () => {
    setContextMenu(null);
  };

  const isHidden = () => {
    if (kanbanBoard && !labelData.color) return true;
    if (kanbanBoard && labelData.kanbanHidden) return true;
    return false;
  };

  return (
    <>
      <Menu
        open={Boolean(contextMenu)}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
      >
        <MenuItem
          onClick={() => {
            jobData?.idLabelsPermanent.splice(
              jobData?.idLabelsPermanent.indexOf(label),
              1
            );
            const db = getFirestore();
            updateDoc(doc(db, "JobData", jobData.id), {
              idLabelsPermanent: jobData.idLabelsPermanent,
            });
            handleClose();
          }}
        >
          Delete Permanent Label
        </MenuItem>
      </Menu>
      {isHidden() ? null : (
        <Chip
          label={labelData.name}
          size="small"
          onClick={() => setLabelMenuOpen && setLabelMenuOpen(true)}
          onContextMenu={isAdmin ? handleContextMenu : noop}
          sx={{
            backgroundColor: labelData.color
              ? labelColours[labelData.color][theme]
              : "rgba(0, 0, 0, 0.4)",
            height: kanbanBoard ? "auto" : 32,
            fontSize: kanbanBoard ? "0.6875rem" : "0.75rem",
            fontWeight: 600,
            color: "white",
            borderRadius: kanbanBoard ? 1 : 2,
            margin: kanbanBoard ? 0 : 0.25,
            marginRight: kanbanBoard ? 1 : 0.5,
            marginBottom: kanbanBoard ? 1 : 0.25,
            boxShadow: kanbanBoard 
              ? "none" 
              : (theme === "dark" 
                  ? "0 2px 8px rgba(0,0,0,0.3)" 
                  : "0 2px 8px rgba(0,0,0,0.15)"),
            transition: "all 0.2s ease-in-out",
            cursor: isAdmin ? "pointer" : "default",
            border: kanbanBoard ? "none" : `1px solid ${labelData.color ? labelColours[labelData.color][theme] : "rgba(0, 0, 0, 0.4)"}`,
            borderColor: kanbanBoard ? "transparent" : (theme === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"),
            "& .MuiChip-label": {
              paddingLeft: kanbanBoard ? "8px" : "12px",
              paddingRight: kanbanBoard ? "8px" : "12px",
              fontSize: kanbanBoard ? "0.6875rem" : "0.75rem",
              fontWeight: 600,
            },
            "&:hover": {
              backgroundColor: kanbanBoard
                ? labelData.color
                  ? labelColours[labelData.color][theme]
                  : "rgba(0, 0, 0, 0.2)"
                : newShade(
                    labelData.color
                      ? labelColours[labelData.color][theme]
                      : "rgba(0, 0, 0, 0.2)",
                    theme === "dark" ? -30 : 30
                  ),
              transform: kanbanBoard ? "none" : (isAdmin ? "translateY(-1px)" : "none"),
              boxShadow: kanbanBoard 
                ? "none" 
                : (isAdmin 
                    ? (theme === "dark" 
                        ? "0 4px 12px rgba(0,0,0,0.4)" 
                        : "0 4px 12px rgba(0,0,0,0.2)")
                    : (theme === "dark" 
                        ? "0 2px 8px rgba(0,0,0,0.3)" 
                        : "0 2px 8px rgba(0,0,0,0.15)")),
            },
          }}
        />
      )}
    </>
  );
};

export default PermanentLabelChip;

const noop = () => {};

const newShade = (hexColor, magnitude) => {
  if (!hexColor || typeof hexColor !== 'string') return '#000000';
  hexColor = hexColor.replace(`#`, ``);
  if (hexColor.length === 6) {
    const decimalColor = parseInt(hexColor, 16);
    let r = (decimalColor >> 16) + magnitude;
    r > 255 && (r = 255);
    r < 0 && (r = 0);
    let g = (decimalColor & 0x0000ff) + magnitude;
    g > 255 && (g = 255);
    g < 0 && (g = 0);
    let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
    b > 255 && (b = 255);
    b < 0 && (b = 0);
    return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  } else {
    return hexColor;
  }
};
